export const AgGridResponse = {
  items: [],
  paging: {
    totalCount: 0,
    take: 0,
    skip: 0
  },
};
